import { Injectable } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';

import { BehaviorSubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CoreMediaService {
  currentMediaQuery: string;
  onMediaUpdate: BehaviorSubject<string> = new BehaviorSubject<string>('');

  private readonly _watched = [
    '(max-width: 575.98px)',
    '(min-width: 576px) and (max-width: 767.98px)',
    '(min-width: 768px) and (max-width: 991.98px)',
    '(min-width: 992px) and (max-width: 1199.98px)',
    '(min-width: 1200px)',
  ];

  constructor(private _breakpointObserver: BreakpointObserver) {
    this.currentMediaQuery = '';
    this._init();
  }

  private _init(): void {
    this._breakpointObserver.observe(this._watched)
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(result => {
        const active = this._watched.find(bp => result.breakpoints[bp]) ?? '';
        if (this.currentMediaQuery !== active) {
          this.currentMediaQuery = active;
          this.onMediaUpdate.next(active);
        }
      });
  }
}
